<template>
	<v-layout v-if="!dataSame">
		<v-flex xs6>
			<old-version-marker/>
			<agency-priority-tree
				v-if="contestId"
				:contest-id="contestId"
				:agency-id="agencyId"
				v-model="old"
				:readonly="true"
				:many-accreditation-countries="manyAccreditationCountries"
			/>
		</v-flex>
		<v-flex xs6>
			<new-version-marker/>
			<agency-priority-tree
				v-if="contestId"
				:contest-id="contestId"
				:agency-id="agencyId"
				v-model="current"
				:readonly="true"
				:many-accreditation-countries="manyAccreditationCountries"
			/>
		</v-flex>
	</v-layout>
</template>

<script>
	import OldVersionMarker from "../../offer/compareComponents/oldVersionMarker";
	import NewVersionMarker from "../../offer/compareComponents/NewVersionMarker";
	import AgencyPriorityTree from "../components/AgencyPriorityTree";

	export default {
		name: "AgencyComparePriorityTree",
		components: {AgencyPriorityTree, NewVersionMarker, OldVersionMarker},

		computed: {
			dataSame() {
				let comparisonResult = JSON.stringify(this.old) === JSON.stringify(this.current);
				if (comparisonResult === false) {
					this.$emit('dataDiffer', true);
				}
				return comparisonResult;
			}
		},

		props: {
			contestId: {},
			agencyId: {},
			old: {},
			current: {},
			manyAccreditationCountries: {type: Boolean, default: false},
		}
	};
</script>

<style scoped>

</style>
